import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { RmaUrlsService } from '@rma/generic/util/environment';
import type { MapRequest, MapResponse } from '@rma/maps/domain';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MapsService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaUrls = inject(RmaUrlsService);

  public queryMapMarkers(request: MapRequest): Observable<MapResponse> {
    const url = this.rmaUrls.apiUrl('v1/Map/QueryMapMarkers');
    return this.httpClient.post<MapResponse>(url, { ...request });
  }
}
